// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Master__Wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Master/style.scss
// module id = 29
// module chunks = 0